import UserRailyOfficerListRequest, {
  UserRailyOfficerListRequestStatusCriteria,
  UserRailyOfficerListRequestOrder,
} from "../../../../api/raily/user/raily-officer/list/user-raily-officer-list.request";
import UserOrder from "../../../../types/user-order";
import UserStatus from "../../../../types/user-status";
import paginationService from "../../../../utils/pagination/pagination.service";
import UserRailyOfficerListParams from "./user-raily-officer-list-params";

const createStatusCriteria = (
  status: UserStatus | undefined,
): UserRailyOfficerListRequestStatusCriteria => {
  switch (status) {
    case UserStatus.ACTIVE:
      return UserRailyOfficerListRequestStatusCriteria.ACTIVE;
    case UserStatus.DELETED:
      return UserRailyOfficerListRequestStatusCriteria.DELETED;
    default:
      return UserRailyOfficerListRequestStatusCriteria.ALL;
  }
};

const createOrder = (
  status: UserOrder | undefined,
): UserRailyOfficerListRequestOrder | undefined => {
  switch (status) {
    case UserOrder.FIRST_NAME_ASC:
      return UserRailyOfficerListRequestOrder.FIRST_NAME_ASC;
    case UserOrder.FIRST_NAME_DESC:
      return UserRailyOfficerListRequestOrder.FIRST_NAME_DESC;
    case UserOrder.LAST_NAME_ASC:
      return UserRailyOfficerListRequestOrder.LAST_NAME_ASC;
    case UserOrder.LAST_NAME_DESC:
      return UserRailyOfficerListRequestOrder.LAST_NAME_DESC;
    case UserOrder.USERNAME_ASC:
      return UserRailyOfficerListRequestOrder.USERNAME_ASC;
    case UserOrder.USERNAME_DESC:
      return UserRailyOfficerListRequestOrder.USERNAME_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: UserRailyOfficerListParams,
): UserRailyOfficerListRequest => {
  return {
    creationStart: params.creationDateFrom,
    creationEnd: params.creationDateTo,
    email: params.email,
    firstName: params.firstName,
    lastName: params.lastName,
    limit: params.pageSize,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
    order: createOrder(params.order),
    statusCriteria: createStatusCriteria(params.status),
    username: params.username,
  };
};

const userRailyOfficerListParamsFactory = { create };

export default userRailyOfficerListParamsFactory;
